/* eslint react-hooks/exhaustive-deps: "warn" */
import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './CompareHero.module.scss';

import type { CompareData } from '../../Compare.types';

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 12.5l4.5 4.5L19 7.5"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CompareHero = ({ data }: { data: CompareData }) => {
  const { t } = useInt();
  const primaryLabel = data.heroActions?.primaryLabel ?? t('Request a data review');
  const secondaryLabel = data.heroActions?.secondaryLabel ?? t('See the comparison');

  return (
    <Section className={styles.root}>
      <div className={styles.inner}>
        <TitleBlock
          size="page"
          align="center"
          title={data.heroTitle}
          description={data.heroDescription}
          className={styles.titleBlock}
        />

        <div className={styles.actions}>
          <Button type="blue" size="xxl" href="/book-a-demo" suffix={<ArrowIcon />}>
            {primaryLabel}
          </Button>

          <Button type="dark-outline" size="xxl" href="#comparison">
            {secondaryLabel}
          </Button>
        </div>

        {data.headStats && (
          <div className={styles.headStats}>
            <div className={styles.headStatCard}>
              <b>{data.headStats[0].value}</b>
              <span>{data.headStats[0].label}</span>
            </div>
            <span className={styles.headStatVs}>vs</span>
            <div className={cn(styles.headStatCard, data.headStats[1].muted && styles.headStatCardMuted)}>
              <b>{data.headStats[1].value}</b>
              <span>{data.headStats[1].label}</span>
            </div>
          </div>
        )}

        <div className={styles.quick}>
          <div className={styles.quickTitle}>{t('How Global Database compares')}</div>
          <div className={styles.quickGrid}>
            {data.quickItems.map((item, i) => (
              <div key={i} className={styles.quickItem}>
                <span className={styles.quickCheck}>
                  <CheckIcon />
                </span>
                <span className={styles.quickText}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};
